<h1 class="titreh1">{{ requete.destination }}</h1>
<p class="nbproduit">
  {{ total }} expériences de voyages, activités et loisirs
</p>
<div class="categories">
  <div class="categorie" *ngFor="let categorie of categories">
    <a [href]="formatLink(objSearch.destination, categorie.categorie[0].slug, objSearch.tag, objSearch.search)"
      [title]="'Catégorie : ' + categorie.categorie[0].name"
      [attr.aria-label]="'Catégorie : ' + categorie.categorie[0].name" *ngIf="categorie.categorie.length > 0">
      <div class="icone-categorie">
        <picture width="18px" height="18px">
          <source [srcset]="icones + '/' + formeWebp(categorie.categorie[0].icone)" type="image/webp"
            [title]="categorie.categorie[0].name" [width]="widthIcone" [height]="widthIcone" />
          <source [srcset]="icones + '/' + formePng(categorie.categorie[0].icone)" type="image/png"
            [title]="categorie.categorie[0].name" [width]="widthIcone" [height]="widthIcone" />
          <img [attr.ngSrc]="icones + '/' + formeWebp(categorie.categorie[0].icone)" [title]="categorie.categorie[0].name"
            [alt]="categorie.categorie[0].name" [width]="widthIcone" [height]="widthIcone"
            [alt]="categorie.categorie[0].name" loading="eager" />
        </picture>
      </div>
      <div class="titre-categorie">
        {{ categorie.count }}
      </div>
      <div class="titre-categorie">
        {{ categorie.categorie[0].name }}
      </div>
    </a>
  </div>
</div>